// @flow
import React from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  padding-top: 100px;
`

const PermanentModal = styled.div`
  top: 100px;
  padding: 15px;
  text-align: center;
`

const OpenHousesClosedOverlay = () => (
  <Container>
    <PermanentModal className="modal">
      <p>Open Houses are currently closed.</p>
      <p>Visit us on Sunday to view our Open House tours.</p>
      <Button to="/properties">OK</Button>
    </PermanentModal>
  </Container>
)

export default OpenHousesClosedOverlay



// WEBPACK FOOTER //
// ./src/views/PropertyTours/OpenHousesClosedOverlay.js